var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewRoundTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98251 12.08C6.70266 12.2976 6.30622 12.2976 6.02637 12.08L1.2457 8.36424C0.965852 8.14658 0.577179 8.14658 0.297335 8.36424C-0.0991116 8.67518 -0.0991116 9.27374 0.297335 9.58467L5.55219 13.6735C6.11188 14.1088 6.897 14.1088 7.46446 13.6735L12.7193 9.58467C13.1158 9.27374 13.1158 8.67518 12.7193 8.36424L12.7115 8.35647C12.4317 8.13881 12.043 8.13881 11.7632 8.35647L6.98251 12.08ZM7.47224 9.73237L12.7271 5.64353C13.1235 5.33259 13.1235 4.72626 12.7271 4.41532L7.47224 0.326485C6.91255 -0.108828 6.12743 -0.108828 5.55997 0.326485L0.305108 4.4231C-0.091338 4.73404 -0.091338 5.34037 0.305108 5.6513L5.55997 9.74014C6.11966 10.1755 6.91255 10.1755 7.47224 9.73237Z",
    fill: "#494949"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRoundTicket);
export default __webpack_public_path__ + "static/media/NewRoundTicket.4c8609cf4a0cf33592b9a78025a58d0d.svg";
export { ForwardRef as ReactComponent };